import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { MagazineTemplate } from "@modules/magazineTemplates/types";
import { MagazineTemplateFormValues } from "@modules/magazineTemplates/validations";

import { createMagazineTemplateService } from "./service";
import { UseCreateMagazineTemplateMutationOptions } from "./types";
import { listMagazineTemplatesQueryKey } from "../../queries";

export function useCreateMagazineTemplateMutation(
  options?: UseCreateMagazineTemplateMutationOptions
) {
  const { open } = useNotification();
  const queryClient = useQueryClient();

  return useMutation<MagazineTemplate, ApiError, MagazineTemplateFormValues>({
    mutationFn: createMagazineTemplateService,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listMagazineTemplatesQueryKey,
        refetchType: "all",
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
